import * as React from 'react';
import { Link, PageProps } from 'gatsby';
import "./Header.scss"
import Hamburger from './Hamburger';
import { MainMenu } from './MainMenu/MainMenu';
import { MobileMenu } from './MobileMenu/MobileMenu';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { getPagePath, getAbsolutePagePath } from '../utils/URLHelper';
import { FormattedMessage } from 'react-intl';
import Search from './Search/Search';
import { isMobile } from "react-device-detect";

const initialState = { menuOpen: false };
type State = Readonly<typeof initialState>;

class Header extends React.Component<
	{
        pageContext?: any;
		programs: any;
		places: any;
		entities: any;
		menuData: PageProps<Queries.MobileMenuFragment>[];
		langs: any[];
		footerCopyrightMessage: string;
		alternateURL: string;
		currPageTitle: string;
		pageTitle?: string;
		location: any;
        topBarInfo?: any;
	} & WrappedComponentProps,
	State
> {
	readonly state: State = initialState;
	private refMenu: MobileMenu;

	constructor(props) {
		super(props);

		if (typeof window !== 'undefined') {
			window.addEventListener('hashchange', this.hashChangeHandler);
		}
	}

	componentDidMount(): void {
		setTimeout(this.hashChangeHandler, 0);

        document.addEventListener('userway:init_completed', function (event) {
            // @ts-ignore
            var instance = event.detail.userWayInstance
            instance.iconVisibilityOff()
        })

        document.addEventListener('userway:render_completed', function () {
            let userwayIcon = document.getElementById('accessibilityWidget')
            
            if(userwayIcon)
            userwayIcon.style.display = 'flex'
        })
	}

	private hashChangeHandler = () => {
		if (typeof window !== 'undefined' && window.location.hash && window.location.hash.indexOf('#map') === 0) {
			if (!this.state.menuOpen) {
				this.refMenu.instantOpen = true;
				this.setState({ menuOpen: true });
			}
			setTimeout(() => {
                this.refMenu.openMap();
			}, 0);
		}
	};

    private mapClickHandler = (e) => {
        e.preventDefault();
        if (!this.state.menuOpen) {
            this.refMenu.instantOpen = true;
            this.setState({ menuOpen: true });
        }
        setTimeout(() => {
            this.refMenu.openMap();
        }, 0);
	};

	private closeHandler = event => {
		if (event) {
			const href = event.target.getAttribute('href');
			if (href && href.indexOf('#') === 0) {
				event.preventDefault();
			}
		}
        // @ts-ignore
        document.querySelectorAll('.toggleOptions').forEach( x=> x.setAttribute("aria-expanded", "false"));
		if (this.state.menuOpen) {
			this.setState({ menuOpen: false });
            document.getElementById('NavigationBg') && document.getElementById('NavigationBg').classList.remove("menu-open")
		} else {
            document.documentElement.style.overflowY = 'scroll';
        }
	};

	private toggleHandler = event => {
		if (event) {
			event.preventDefault();
		}

        this.setState({
            menuOpen: !this.state.menuOpen
        }, () => {
            if(this.state.menuOpen) {
                document.getElementById('NavigationBg') && document.getElementById('NavigationBg').classList.add("menu-open")
                document.getElementById('progress-container') && document.getElementById('progress-container').classList.add("inMenu")
                document.documentElement.style.overflowY = 'hidden';
            } else {
                document.getElementById('NavigationBg') && document.getElementById('NavigationBg').classList.remove("menu-open")
                document.getElementById('progress-container') && document.getElementById('progress-container').classList.remove("inMenu")
                document.documentElement.style.overflowY = 'scroll';
            }
        });
	};

    private isTapStory = () => {
		const splitLocation = this.props.location.pathname.split("/").filter(split => split != "")
        if(this.props.langs[1].selected)
            splitLocation.pop()
		return splitLocation.includes("tap") && splitLocation.length >= 3
	}

    private handleAccessibilityWidget = (event) => {
        if (event) {
			event.preventDefault();
		}
        // @ts-ignore
        typeof UserWay !== 'undefined' && UserWay.widgetOpen()
    }

    private handleClick = () => {
        document.getElementById('chatBtn').click()
    }

    private toggleOptions = (e, megaMenu) => {
        e.preventDefault();
        var elem = e.target.tagName === 'path' ? e.target.parentElement.parentElement : e.target.tagName === 'svg' ? e.target.parentElement : e.target
        var x = elem.getAttribute("aria-expanded")
        if(x !== null) {
            var theSpan = typeof document !== 'undefined' && document.createElement("span"); 
            theSpan.id = 'close-megamenu'
            theSpan.className = 'closeMegamenu'
            
            if (x == "true") {
                x = "false"
                document.documentElement.classList.remove('megamenuOpen');
            } else {
                x = "true"
                if(megaMenu) {
                    document.documentElement.classList.add('megamenuOpen');
                }
            }
            // @ts-ignore
            document.querySelectorAll('.toggleOptions').forEach( x=> x.setAttribute("aria-expanded", "false"));
            elem.setAttribute("aria-expanded", x);
    
            if(megaMenu) {
                var activeItem = elem.nextElementSibling?.querySelectorAll('ul > div#secondaryMenuList > li#active > a')[0];
                if(activeItem) {
                    elem.nextElementSibling?.querySelectorAll('ul > div#secondaryMenuList > li#active > a')[0]?.click()
                } else {
                    elem.nextElementSibling?.querySelectorAll('ul > div#secondaryMenuList > li:first-child > a')[0]?.click()
                }
            }
        }
    };

	private closeDialogue = () => {
        document.getElementById('explore-qf').setAttribute("aria-expanded", "false");
    }

	render() {
        const currLanguage = this.props.langs[1].selected ? this.props.langs[1] : this.props.langs[0];
		return (
			<header className={`site-head`}>
                <div className={`container site-head__inner`}>
                    <Link aria-current="page" title="Qatar Foundation Homepage" tabIndex={0} aria-label="Qatar Foundation Homepage" className="logo" to={this.props.langs[1].selected ? 'https://www.qf.org.qa' + '/ar' : 'https://www.qf.org.qa' + '/'}>
                        <svg width="60" height="40" viewBox="0 0 40 26" xmlns="http://www.w3.org/2000/svg"><path d="M39.73 12.34c-.1-.15-.1-.26 0-.4.12-.13.18-.28.11-.46a9.58 9.58 0 0 1-.21-.57c-.04-.13-.1-.27-.1-.4.01-.07.13-.14.2-.22.04-.06.09-.13.1-.2.07-.26.01-.48-.2-.64-.35-.26-.46-.6-.19-1.01.18-.27.29-.6.18-.9a3.13 3.13 0 0 1-.2-1.03c0-.4-.3-.53-.65-.41-.07.02-.13.08-.2.12l-.5.32c-.12-.22-.1-.42-.06-.62.05-.32 0-.45-.26-.61.1-.34.01-.5-.4-.78-.32-.2-.63-.08-.93 0-.32-.45-.7-.54-1.16-.3-.05.03-.16.02-.2-.02a.68.68 0 0 1-.16-.25c-.07-.2-.17-.34-.36-.42a.22.22 0 0 1-.1-.1c-.16-.35-.4-.48-.77-.39-.13.03-.24.03-.35-.06-.3-.24-.66-.24-.91.1-.07.09-.15.13-.3.1-.3-.06-.49.07-.6.37-.05.13-.09.27-.15.4-.15.33-.38.57-.78.66.05-.23.24-.42.12-.66-.12-.25-.37-.21-.6-.26l.08-.1c.34-.36.5-.96.15-1.48-.25-.37-.8-.48-1.15-.18l-.2.17c-.12-.13-.2-.27-.33-.35-.3-.18-.72-.09-.98.15-.44.4-.41.41-.9.21a.47.47 0 0 0-.59.17l-.1.15c-.64-.27-.64-.27-1.03.2-.33-.07-.51-.11-.72.61-.17-.02-.22-.05-.31-.2-.11-.19-.37-.26-.58-.19-.22.08-.25.28-.28.44l-.56.04c-.08.01-.15.11-.22.1-.32-.02-.54.14-.71.42-.1-.1-.22-.18-.25-.28-.05-.23.02-.3.26-.37.31-.1.56-.32.32-.7a.26.26 0 0 1-.03-.19c.07-.38-.13-.65-.51-.65-.16 0-.23-.05-.24-.22a.82.82 0 0 0-.13-.36c-.1-.16-.3-.2-.42-.06-.11.13-.16.07-.28.01a.73.73 0 0 0-.48-.08c-.16.04-.1.24-.1.38 0 .06.07.12.08.2l-.03.2c-.04-.04-.11-.07-.14-.11-.18-.35-.44-.47-.8-.34-.17.06-.32.16-.44.22l-.56-.28c-.03 0-.04-.04-.05-.07-.05-.22-.2-.33-.4-.4-.06-.01-.15-.04-.16-.08-.06-.2-.23-.26-.38-.34-.52-.26-1-.09-1.25.45-.02.06-.04.11-.08.15-.09.1-.29.1-.3-.02-.07-.33-.3-.45-.6-.53-.05-.01-.12-.07-.14-.12-.08-.25-.5-.37-.72-.16a.78.78 0 0 1-.8.22.48.48 0 0 0-.35.07c-.18.13-.34.3-.5.45-.24.24-.24.25-.55.11-.22-.1-.43-.15-.67 0-.09.06-.23.07-.35.06-.24-.03-.46-.05-.62.2-.07.11-.18.15-.32.07-.35-.2-.55-.17-.86.12-.13.12-.27.18-.45.07-.21-.14-.45-.1-.68-.05-.29.06-.35.14-.36.43-.01.11-.05.15-.16.16-.3.01-.4.1-.44.37l-.13-.05c-.32-.09-.6.07-.71.4-.02.05-.1.1-.16.12-.28.09-.39.26-.32.54l.07.22c.08.21.03.32-.17.37l-.12.04a.44.44 0 0 0-.09.7c.35.33.27.66-.18.82-.21.07-.4.19-.47.41-.12.34-.19.4-.54.4-.24 0-.47.06-.59.29-.15.3-.4.35-.68.38a.89.89 0 0 0-.68.41c-.16.24-.13.5-.01.77.04.1.04.23.01.34-.05.25-.05.49.12.7.1.1.02.16-.08.18-.07 0-.15-.03-.22-.04-.13-.01-.26-.04-.39-.04-.28 0-.5.2-.8.17-.34-.04-.56.33-.44.64l.12.24c0 .02-.02.04-.03.05-.33.32-.32.46 0 .8.2.2.27.45.2.72-.05.2-.15.37-.21.55-.1.28-.02.44.25.53l.48.19c-.1.13-.19.22-.25.33-.13.23-.07.47.16.6a.5.5 0 0 0 .5-.03c.1-.05.18-.14.28-.17.12-.05.26-.15.4-.02-.06.13-.13.25-.17.37-.09.24-.02.38.23.44.4.1.78.11 1.14-.13.1-.07.23-.1.35-.14l.03.06c-.06.08-.12.15-.17.24-.14.2-.08.42.14.5.2.06.4.09.6.11.22.03.27.07.21.3-.07.31.05.58.33.75l.62.4c.05.03.1.08.12.13.14.47.66.51 1.06.5.18-.01.4-.05.52.03.33.24.7.31 1.07.33.19.01.27.1.37.23.08.1.2.2.32.26.11.06.25.07.37.06.29-.02.58-.07.87-.1v.07c0 .47.09.58.56.66.2.03.4 0 .61 0 .06.38.12.46.5.54.2.05.41.06.62.1.28.03.34.12.3.4v.35c0 .28.25.44.5.32.12-.05.2-.05.28.03.36.31.6.67.51 1.2-.07.43.03.84.3 1.2l.9 1.19.14.25a337.06 337.06 0 0 0-13.45 1.15h-.04V26h36.28v-.24l-.09-.02c-.33-.04-7.02-.68-9.35-.87l-4.03-.26c-.34 0-.67-.03-1.05-.04.2-.33.37-.63.57-.92.11-.16.24-.31.38-.44.19-.18.41-.32.42-.61 0-.04.04-.09.06-.12l.45-.62c.18-.27.32-.58.52-.84.18-.23.4-.47.64-.62.6-.4 1.23-.75 1.85-1.1.15-.1.3-.15.49-.23v.2c.01.3.2.48.5.41.22-.05.42-.16.62-.28.1-.05.16-.06.28-.05.17.04.37.06.54.02.37-.09.56-.34.53-.73.49-.08.59-.24.5-.78.1-.03.22-.04.32-.06.06.31.24.5.63.35.08.12.13.27.23.35.33.27 1.07.36 1.4-.19.04-.07.15-.13.24-.14.53-.1.97-.35 1.29-.8.08-.1.14-.23.21-.34.11.05.19.1.27.12.26.1.32.06.41-.2.08-.2.17-.41.27-.6.08-.15.2-.2.38-.12.23.12.48.12.68-.07.15-.15.26-.36.41-.56h.23c.33 0 .44-.08.48-.41.03-.2.03-.42 0-.62-.04-.25-.11-.5-.17-.75l.19.07c.41.12.55-.02.6-.38.08-.41 0-.82-.24-1.17M19.5 20.5c-.04.23-.07.46-.13.7-.04.13-.1.27-.16.4-.18.4-.23.82-.22 1.24.02.56-.1 1.08-.35 1.57-.03.06-.1.11-.16.12-.44 0-.88.03-1.31-.01-.16-.01-.32-.16-.46-.28l-1.27-1.16a1.74 1.74 0 0 1-.55-1.3v-.44c0-.42.2-.69.62-.67.33.01.6-.07.87-.22.17-.1.34-.1.53.01.47.26 1.08-.03 1.15-.47 0-.03.03-.05.05-.08.33.21.52.2.93-.1l.45.53c.02.04.02.1.01.16m5.95-.98c-.11.2-.18.4-.27.61-.11.28-.3.49-.57.62-.19.1-.3.23-.39.43-.2.53-.47 1.02-.87 1.45-.17.19-.3.43-.42.67-.25.52-.7.8-1.19 1.05-.2.1-.4.16-.64.15h-.85c-.07-.32-.16-.62-.2-.93a4.1 4.1 0 0 1 .32-2.16c.1-.22.17-.46.28-.68.07-.15.15-.3.26-.44.13-.17.3-.24.53-.18.26.06.53.11.8.14.3.02.4-.1.4-.4v-.15c0-.09.03-.15.15-.12.13.03.27 0 .4.01.31 0 .43-.11.45-.42 0-.07.03-.14.05-.23.22.2.38.33.76.06.12.37.39.36.7.28a.37.37 0 0 1 .18 0c.12.04.23.07.12.24" fill="#000" fill-rule="evenodd"></path></svg>
                    </Link>
                    <div className="links" aria-label="links">
                        <ul className="split" role="list">
                            <li className={'link'}>
                                <Link id='explore-qf' aria-expanded={false} to="#" onClick={e => this.toggleOptions(e, true)}>
                                    <FormattedMessage id={'Explore QF'} />
                                    <svg width="12" height="8" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.91.38l.73.68-5.6 6.07L.41 1.06l.74-.68 4.87 5.28z" fill="#000" fillRule="nonzero" />
                                    </svg>
                                </Link>
                                <div id='secondaryMenuClass' className={`secondaryMenu align-content full-bleed flow-content`}>
                                    <div className='gridWrapper container'>
                                        <div className='intro'>
                                            <h3 className='bold'><FormattedMessage id={'Explore QF your way'} /></h3>
                                            <br />
                                            <h3 className='text'>
                                                <FormattedMessage id={'explore_qf_content'} />
                                            </h3>
                                        </div>
                                        <div className='linksInline'>
                                            <Link onClick={this.closeDialogue} to={`https://www.qf.org.qa${currLanguage.langKey === 'ar-QA' ? '/ar' : ''}/community-members`}><FormattedMessage id={'Community members'} /></Link>
                                            <Link onClick={this.closeDialogue} to={`https://www.qf.org.qa${currLanguage.langKey === 'ar-QA' ? '/ar' : ''}/prospective-students`}><FormattedMessage id={'Prospective students'} /></Link>
                                            <Link onClick={this.closeDialogue} to={`https://www.qf.org.qa${currLanguage.langKey === 'ar-QA' ? '/ar' : ''}/researchers-and-entrepreneurs`}><FormattedMessage id={'Researchers and Entrepreneurs'} /></Link>
                                            <Link onClick={this.closeDialogue} to={`https://www.qf.org.qa${currLanguage.langKey === 'ar-QA' ? '/ar' : ''}/journalists-and-media`}><FormattedMessage id={'Journalists and Media'} /></Link>
                                            <Link onClick={this.closeDialogue} to={`https://www.qf.org.qa${currLanguage.langKey === 'ar-QA' ? '/ar' : ''}/job-seekers`}><FormattedMessage id={'Job Seekers'} /></Link>
                                            <Link onClick={this.closeDialogue} to={`https://www.qf.org.qa${currLanguage.langKey === 'ar-QA' ? '/ar' : ''}/new-to-qatar-foundation`}><FormattedMessage id={'New to Qatar Foundation'} /></Link>
                                        </div>
                                        <div className={'askBotaina'}>
                                            <div className='text-wrapper'>
                                                <h3 className='bold'><FormattedMessage id={'Ask Botaina'} /></h3>
                                                <p>
                                                    <FormattedMessage id={'botaina_content'} />
                                                    <br />
                                                    <Link to={'/'} onClick={this.handleClick} data-elastic-exclude className={`text-style-body ctaLink`}>
                                                        <FormattedMessage id={'Lets chat'} />
                                                    </Link>
                                                </p>
                                            </div>
                                            <div className={'botaina'} onClick={this.handleClick}>
                                                <img width={90} height={122} src="/botaina.gif" alt="Botaina" loading="lazy" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className={'link'}>
                                <Link to={'https://www.qf.org.qa' + getPagePath('', 'press')}>
                                    <FormattedMessage id={'media_center'} />
                                </Link>
                            </li>
                            <li className={'link'}>
                                <a href={getAbsolutePagePath('ec_website')} target='_blank'>
                                    <FormattedMessage id={'Education City'} />
                                </a>
                            </li>
                            <li className='iconsWrapper' tabIndex={0}>
                                <div className={'accessibilityWidget'}>
                                    <button className={'accessibilityIcon'} onClick={this.handleAccessibilityWidget}>
                                        <span>{this.props.intl.formatMessage({ id: 'accessibility' })}</span>
                                        <svg className={'accessibilityIcon'} width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <title>accessibility_icon</title>
                                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="Group" transform="translate(0.800000, 0.800000)">
                                                    <g transform="translate(4.263565, 1.973684)" className={'line'} fill-rule="nonzero">
                                                        <circle id="Oval" cx="5.60485624" cy="2.17105263" r="2.17105263"></circle>
                                                        <path d="M0.407487816,5.78947368 L3.4338036,7.5 L3.4338036,10.1315789 L1.65748782,14.6052632 C1.46011939,15.0657895 1.59169834,15.6578947 2.05222466,15.9210526 C2.57854045,16.25 3.30222466,15.9868421 3.49959308,15.4605263 L5.60485624,10.3289474 L6.06538255,10.3289474 L8.10485624,15.3947368 C8.30222466,15.8552632 8.76275097,16.1842105 9.28906676,16.0526316 C9.88117203,15.9210526 10.2101194,15.2631579 10.012751,14.6710526 L8.17064571,10.1315789 L8.17064571,7.5 L11.131172,5.78947368 C11.3943299,5.65789474 11.5916983,5.32894737 11.5916983,5 L11.5916983,5 C11.5916983,4.34210526 10.8680141,3.88157895 10.2759089,4.21052632 L8.10485624,5.39473684 L3.49959308,5.39473684 L1.32854045,4.21052632 C0.736435184,3.88157895 0.0127509734,4.27631579 0.0127509734,5 L0.0127509734,5 C-0.0530385003,5.32894737 0.144329921,5.65789474 0.407487816,5.78947368 Z" id="Path"></path>
                                                    </g>
                                                    <circle id="Oval" className={'circle'} stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" cx="10" cy="10" r="10"></circle>
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                            </li>
                            {
                                isMobile && <Search inMenu={true} currLanguage={currLanguage} />
                            }
                        </ul>
                    </div>
                </div>
                <div className={`container`}>
                    {
                        !this.isTapStory() && (
                        isMobile ? (
                            <>
                                <MobileMenu
                                    ref={ref => (this.refMenu = ref)}
                                    programs={this.props.programs}
                                    places={this.props.places}
                                    entities={this.props.entities}
                                    closeHandler={this.closeHandler}
                                    open={this.state.menuOpen}
                                    footerCopyrightMessage={this.props.footerCopyrightMessage}
                                    currLanguage={currLanguage}
                                    // @ts-ignore
                                    data={this.props.menuData}
                                    intl={this.props.intl}
                                    id="mobilemenu"
                                    alternateURL={this.props.alternateURL}
                                    langs={this.props.langs}
                                    location={this.props.location}
                                    pageContext={this.props.pageContext}
                                >
                                </MobileMenu>
                                <Hamburger toggleHandler={this.toggleHandler} />
                                <MainMenu
                                    programs={this.props.programs}
                                    places={this.props.places}
                                    entities={this.props.entities}
                                    handleMap={this.mapClickHandler}
                                    closeHandler={this.closeHandler}
                                    open={this.state.menuOpen}
                                    footerCopyrightMessage={this.props.footerCopyrightMessage}
                                    currLanguage={currLanguage}
                                    langs={this.props.langs}
                                    // @ts-ignore
                                    data={this.props.menuData}
                                    intl={this.props.intl}
                                    id="mainmenu-desktop"
                                    location={this.props.location}
                                    alternateURL={this.props.alternateURL}
                                >
                                </MainMenu>
                            </>

                        ) : (
                            <>
                                <MobileMenu
                                    ref={ref => (this.refMenu = ref)}
                                    programs={this.props.programs}
                                    places={this.props.places}
                                    entities={this.props.entities}
                                    closeHandler={this.closeHandler}
                                    open={this.state.menuOpen}
                                    footerCopyrightMessage={this.props.footerCopyrightMessage}
                                    currLanguage={currLanguage}
                                    // @ts-ignore
                                    data={this.props.menuData}
                                    intl={this.props.intl}
                                    id="mobilemenu"
                                    alternateURL={this.props.alternateURL}
                                    langs={this.props.langs}
                                    location={this.props.location}
                                    pageContext={this.props.pageContext}
                                >
                                </MobileMenu>
                                <MainMenu
                                    programs={this.props.programs}
                                    places={this.props.places}
                                    entities={this.props.entities}
                                    handleMap={this.mapClickHandler}
                                    closeHandler={this.closeHandler}
                                    open={this.state.menuOpen}
                                    footerCopyrightMessage={this.props.footerCopyrightMessage}
                                    currLanguage={currLanguage}
                                    langs={this.props.langs}
                                    // @ts-ignore
                                    data={this.props.menuData}
                                    intl={this.props.intl}
                                    id="mainmenu-desktop"
                                    location={this.props.location}
                                    alternateURL={this.props.alternateURL}
                                >
                                </MainMenu>
                            </>
                        ))
                    }
                </div>
            </header>
		);
	}
}

export default injectIntl(Header);